import { render } from "./StaticPage.vue?vue&type=template&id=5698ccd8"
import script from "./StaticPage.vue?vue&type=script&lang=ts"
export * from "./StaticPage.vue?vue&type=script&lang=ts"
script.render = render

export default script